var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelenetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC421;}\n\t.st1{fill:#FFC410;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.9,14.5C77.1,8,72.1,2.9,65.6,2.1c0,0-10.4-1.6-25.6-1.6S14.4,2.1,14.4,2.1C7.9,2.9,2.9,8,2.1,14.5 c0,0-1.6,11.7-1.6,25.5s1.6,25.5,1.6,25.5C2.9,72,7.9,77.1,14.4,77.9c0,0,10.4,1.6,25.6,1.6s25.6-1.6,25.6-1.6 c6.5-0.8,11.6-5.9,12.3-12.4c0,0,1.6-11.7,1.6-25.5S77.9,14.5,77.9,14.5 M67.5,58.5c-0.6,4.7-4.2,8.4-8.9,9c0,0-7.5,1.2-18.6,1.2 s-18.6-1.2-18.6-1.2c-4.7-0.6-8.4-4.2-8.9-9c0,0-1.2-8.4-1.2-18.5c0-10,1.2-18.5,1.2-18.5c0.6-4.7,4.2-8.4,8.9-9 c0,0,7.5-1.2,18.6-1.2s18.6,1.2,18.6,1.2c4.7,0.6,8.4,4.2,8.9,9c0,0,1.2,8.4,1.2,18.5C68.6,50,67.5,58.5,67.5,58.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,32.4v-4.1c0-0.4-0.5-0.5-0.5-0.5c-2-0.5-4-0.8-5.9-0.9c-1.9,0-3.7,0.2-5.5,0.6c0,0-0.5,0.1-0.5,0.6v4 c0,0.8,0.5,0.6,0.5,0.6c1.7-0.2,3.5-0.4,5.4-0.3c2,0,4,0.2,5.8,0.6C55.4,32.9,56,33,56,32.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,29.9c0-5.1-6.1-5.1-6.1-5.1s-6.1,0-6.1,5.1s6.1,5.1,6.1,5.1S36,35.1,36,29.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,55.7c-7.9,0-14.5-4.6-16.6-6.3c0,0-0.7-0.7-0.7-1.3V46c0-1.1,0.8-0.5,0.8-0.5c2.2,1.4,8.4,4.7,16.5,4.7 s14.3-3.5,16.5-4.7c0,0,0.8-0.6,0.8,0.5v2.1c0,0.6-0.7,1.3-0.7,1.3C54.5,51.1,47.9,55.7,40,55.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelenetLogo);
export default __webpack_public_path__ + "static/media/telenet_logo.ffe6eb9e709e09763365ee7a8471bfa6.svg";
export { ForwardRef as ReactComponent };